import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository, ITokenService, IStorageService } from '../../../domain/ports';

export class LogoutUseCase implements IUseCase<void, void> {
  constructor(
    private readonly authRepository: IAuthRepository,
    private readonly tokenService: ITokenService,
    private readonly storageService: IStorageService,
  ) {}

  async execute(): Promise<void> {
    try {
      await this.authRepository.logout();
    } catch {
      // Continuer la deconnexion meme en cas d'erreur API
    } finally {
      this.tokenService.clearTokens();
      this.storageService.clearUser();
    }
  }
}
